import cleanDeep from "clean-deep";
import { useEffect } from "react";
import { NotificationManager } from "react-notifications";
import { connect } from "react-redux";
import { Actions as COMPANY_ACTIONS } from "../../../store/actions/companyActions";
import { Actions as PAY_SCHEDULE_ACTIONS } from "../../../store/actions/payScheduleActions";

import { CheckCircleIcon, PlusIcon } from "@heroicons/react/20/solid";
import { cloneDeep, orderBy } from "lodash";
import AdvancedSettingsModal from "../modals/AdvancedSettingsModal";
import UpdatePeriodTypeModal from "../modals/UpdatePeriodTypeModal";
import PaySchedule from "./PaySchedule";

const Payroll = ({ paySchedules, payScheduleGetList, addPaySchedule, updateCompanyDetails, currentOrg, disabled, payScheduleTypes }) => {
	const onSubmit = (e) => {
		e.preventDefault();
		e.stopPropagation();

		const invalidPaySchedules =
			paySchedules?.length > 0 &&
			paySchedules?.find(
				(paySchedule) =>
					!(
						paySchedule.name?.replace(/\s/g, "") &&
						paySchedule.payDay?.type &&
						paySchedule.payDay?.value &&
						paySchedule.deadline?.type &&
						paySchedule.deadline?.value
					),
			);

		if (invalidPaySchedules)
			return NotificationManager.error("Please ensure all fields are filled before saving!", "Pay Schedules");

		updateCompanyDetails(
			cleanDeep(
				{
					org: String(currentOrg),
					paySchedules: paySchedules?.map((schedule) => {
						schedule.temporary = undefined;
						return schedule;
					}),
				},
				{ emptyStrings: false, emptyArrays: false, emptyObjects: false },
			),
		);
	};

	useEffect(() => {
		if (!paySchedules) {
			payScheduleGetList();
		}
	}, []);

	return (
		<form
			onSubmit={onSubmit}
			style={{ paddingBottom: 30 }}
			className="px-8"
		>
			<UpdatePeriodTypeModal />
			<AdvancedSettingsModal />

			{payScheduleTypes?.map(({title,type,titlePlural,skipFiltering}) => (
				<div className="form-section col-xs-12">
					<div className="col-xs-12">
						<div className="pull-left">
							<h4>{titlePlural}</h4>
						</div>
						{!disabled && (
							<button
								className="btn btn-success pull-right"
								type="button"
								onClick={() => {
									addPaySchedule(type ?? null);
								}}
							>
								<PlusIcon style={{ height: "1.5em", float: "left", marginRight: 5 }} />
								<div style={{ float: "left" }}>Add {title}</div>
							</button>
						)}
					</div>
					<div className="col-xs-12 pl-0 pb-6">
						{paySchedules?.filter(p => skipFiltering || p?.type === type )?.map((paySchedule) => (
							<div>
								<PaySchedule
									key={paySchedule.id}
									paySchedule={paySchedule}
								/>
								{/* <div className="col-xs-1" style={{paddingTop: 17.5}}>
								  <button
									className="btn-sm btn-default"
									type="submit"
									data-type="remove"
									onClick={removePaySchedule(paySchedule.id)}
								  >
									Remove
								  </button>
								</div>
								<div className="clearfix" /> */}
							</div>
						))}
					</div>
				</div>
			))}

			<div className="clearfix" />

			<div className="col-xs-12 pr-0 text-right">
				{!disabled && (
					<button
						className="btn btn-success"
						type="submit"
					>
						<CheckCircleIcon style={{ height: "1.5em", float: "left" }} />
						<div style={{ float: "left" }}>Save</div>
					</button>
				)}
			</div>
		</form>
	);
};

const mapStateToProps = (state) => {
	const settings = cloneDeep(state.company?.settings);

	if (typeof settings?.showEmployerContributions == "undefined") {
		settings.showEmployerContributions = true;
	}

	const jurisdiction = state.company?.settings?.jurisdiction

	const payScheduleTypes = [
		{ title: "Pay Schedule", titlePlural: "Pay Schedules", skipFiltering: true },
		{ title: "CIS Pay Schedule", titlePlural: "CIS Pay Schedules", type: "cis", show: ({enable, jurisdiction}) => enable?.cis && jurisdiction === "UK" },
	].filter((type) => !type.show || type.show(state.company?.settings));


	return {
		sickPaySchemes: state.company?.settings?.sickPaySchemes,
		payScheduleTypes,
		jurisdiction,
		paySchedules: state.company?.settings?.paySchedules,
		allowances: state.company?.settings?.allowances,
		hasDepartments: state.company?.settings?.departments?.length > 0,
		currentOrg: state.company?.settings?.org,
		settings,
		firstYear: orderBy(state.payPeriods?.periods || [], "year", "asc")?.[0]?.year - 1,
		disabled:
			state?.permissions?.my?.permissions?.settings == "Read" || state?.company?.settings?.status == "Archived",
		currency: state.company?.settings?.currency,
	};
};

const mapDispatchToProps = (dispatch) => ({
	updateSetting: (field, newValue) => dispatch(COMPANY_ACTIONS.updateSetting(field, newValue, false)),
	updateCompanyDetails: (body) => dispatch(COMPANY_ACTIONS.updateCompanyDetails(body)),
	addPaySchedule: (type) => dispatch(PAY_SCHEDULE_ACTIONS.addPaySchedule({ parent: null, newCompany: false, payScheduleType: type })),
	payScheduleGetList: () => dispatch(PAY_SCHEDULE_ACTIONS.payScheduleGetList()),
	removePaySchedule: () => dispatch(PAY_SCHEDULE_ACTIONS.removePaySchedule()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Payroll);
